import { join, map, pipe, toPairs } from 'ramda'

const encodeData = pipe(
  toPairs,
  map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`),
  join('&')
)

export default encodeData
